'use client';

import { Typography } from '@workspace/ui/common/Typography/Typography';
import { cn } from '@workspace/lib';
import { ContactSupportProps } from './contact-support.types';
import { useContactSupport } from './lib/useContactSupport';
import { ContactInfo } from './ui/ContactInfo';
import { ContactSupportButtons } from './ui/ContactSupportButtons';
import { ContactSupportImage } from './ui/ContactSupportImage';
import { NewsletterSection } from './ui/NewsletterSection';

export function ContactSupport({
  heading,
  description,
  image,
  imageAlt = 'Contact support image',
  imageHref,
  imageTarget,
  contactItems,
  button = [],
  newsletterHeading,
  newsletterDescription,
  enableNewsletter = false,
  subPlaceholder = 'Enter your email address',
  subCtaLabel = 'Subscribe',
}: ContactSupportProps) {
  const { headingWithBreaks } = useContactSupport({
    heading,
    description,
    image,
    imageAlt,
    imageHref,
    imageTarget,
    contactItems,
    button,
    newsletterDescription,
    newsletterHeading,
    enableNewsletter,
    subPlaceholder,
    subCtaLabel,
  });

  return (
    <section className="porta-container py-4xl pb-4xl md:px-0 px-md md:pt-4xl pt-2xl bg-white!">
      <div className={cn('flex md:flex-row gap-lg md:gap-2xl md:items-center md:justify-center')}>
        <ContactSupportImage image={image} imageAlt={imageAlt} imageHref={imageHref} imageTarget={imageTarget} />
        <div className="flex flex-col max-w-130 w-full mx-auto md:mx-0 gap-lg md:gap-xl">
          <div className="flex flex-col gap-sm">
            <Typography
              variant="h2"
              className={cn('font-heading font-bold! tracking-normal! text-raisin-black! whitespace-pre-line ')}
              styleVariant="h3"
            >
              {headingWithBreaks}
            </Typography>
            <div className="flex flex-col gap-lg md:gap-sm">
              <Typography variant="bodyMd" className="text-black">
                {description}
              </Typography>

              <div className="flex flex-col gap-8 md:gap-6">
                <ContactInfo items={contactItems} />
                {button.length > 0 && <ContactSupportButtons buttons={button} />}
              </div>
            </div>
          </div>

          {enableNewsletter && (
            <NewsletterSection
              newsletterHeading={newsletterHeading}
              newsletterDescription={newsletterDescription}
              subPlaceholder={subPlaceholder}
              subCtaLabel={subCtaLabel}
            />
          )}
        </div>
      </div>
    </section>
  );
}
